import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';

import appTheme from '../../../../themes/Theme';
import { TextField, Select } from '../../../Shared';

export const FlexCenterContainerMap = styled.div`
  display: flex;
  justify-content: center;
`;
export const StyledWrapperMap = styled.div`
  width: 100%;
`;

export const StyledHeaderMap = styled.h2`
  text-align: center;
`;

export const StyledWrapper = styled.div`
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
`;

export const StyledTextContent = styled.p`
  margin: 20px 16px 0 0;
  color: ${appTheme.textColor};
`;

export const useStylesGrid = makeStyles({
  root: {
    marginBottom: 8,
  },
  button: {
    marginTop: 24,
    '&:disabled': {
      backgroundColor: 'gray',
      color: '#e6d3d3',
    }
  }
})

export const StyledTextField = styled(TextField)`
  width: 100%;
  min-width: 350px;
  max-width: 400px;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  min-width: 224px;
  max-width: 400px;
`;

export const StyledSelectReason = styled(Select)`
  width: 100%;
  min-width: 350px;
  max-width: 400px;
  margin-top: 8px;
`;

export const StyledSelectWeather = styled(Select)`
width: 100%;
min-width: 350px;
max-width: 400px;
margin-top: 8px;
`;

export const StyledWrapFormStatus = styled.div`
  display: flex;
  /* justify-content: flex-start; */
  margin-top: 16px;
`;

export const StyledFormStatus = styled.div`
  width: 100%;
  max-width: 760px;
`;

export const StyledNotificationButton = styled(NotificationsNoneIcon)`
  margin-left: auto;
  cursor: pointer;
`;
